module.exports = __webpack_public_path__ + "static/Theinhardt-Italic-db7e67a2b5af2e4a7e073f6493272561.otf";